(function () {
  const threshold = 12;
  let ticking = false;

  function updateHeaderInfoBars() {
    document.querySelectorAll('.shopify-section--header [data-header-info-bar]').forEach((bar) => {
      const section = bar.closest('.shopify-section--header');
      if (!section) return;
      section.classList.toggle('header-section--info-collapsed', window.scrollY > threshold);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateHeaderInfoBars();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  function init() {
    updateHeaderInfoBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (ev) => {
    if (ev.target?.classList?.contains('shopify-section--header')) {
      updateHeaderInfoBars();
    }
  });
})();
